import type { ElementType } from 'react';

// Tamagui's generated unions exceed the TypeScript compiler's representation limit when rendered
// directly. Keep the assertion at the vendor boundary and use Tamagui's own
// exported prop types at call sites.
export const tamaguiElement = <Props>(component: unknown): ElementType<Props> =>
  // eslint-disable-next-line typescript/no-unsafe-type-assertion -- This is the single vendor boundary for Tamagui's generated component unions.
  component as ElementType<Props>;

const isObjectLike = (value: unknown): value is object =>
  (typeof value === 'object' && value !== null) || typeof value === 'function';

export const tamaguiStatic = (component: unknown, key: PropertyKey): unknown => {
  if (!isObjectLike(component)) {
    throw new TypeError(`Tamagui static "${String(key)}" is missing from a non-object component`);
  }

  const value = Reflect.get(component, key);
  if (value == null) {
    throw new TypeError(`Tamagui static "${String(key)}" is missing`);
  }

  return value;
};
